<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pa-3">
               <movimiento-crud />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import MovimientoCrud from "./MovimientoCrud";
    export default {
        name: "Movimiento",
        components: {MovimientoCrud}
    }
</script>

<style scoped>

</style>

